// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__UiAId","hidden":"Banner_hidden__oredo"};